import events, { ToastType } from "@/events";

export const toast = (type: ToastType, text: string) => events.emit('toast', { type, text });
export const dialog = (title: string, text: string) => new Promise(resolve => {
    events.emit('dialog:show', { title, text, callback: (result) => resolve(result) })
});
export const inputDialog = (title: string, text: string) => new Promise<{ result: boolean, input: string | undefined }>(resolve => {
    events.emit('dialog:show', { title, text, input: true, callback: (result, input) => resolve({ result, input }) })
});

export const loader = () => events.emit('load:start');
export const done = () => events.emit('load:done');

export function downloadFile(blob: Blob, fileName: string) {
    const blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', fileName);
    if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    setTimeout(function () {
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }, 200);
}

export function fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        if (successful) toast('info', 'Copied to clipboard');
        else toast('error', 'Failed to copy to clipboard');
    } catch (err) {
        toast('error', 'Failed to copy to clipboard');
    }

    document.body.removeChild(textArea);
}
export function unify(value: number) {
    if (value / 1000 < 1) {
        return value;
    } else if (value / 100_000 < 1) {
        return (value / 1000).toFixed(1) + 'k';
    } else {
        return (value / 1000).toFixed(0) + 'k';
    }
}

export function copyTextToClipboard(text: string) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        toast('info', 'Copied to clipboard');
    }, function (err) {
        toast('error', 'Failed to copy to clipboard');
    });
}
